import { WhyChooseTechSectionType } from "../../../utility/types/generaTypes";
import WhyChooseTechCard from "../whyChooseTechCard/WhyChooseTechCard";
import "./WhyChooseTechnologySection.css";

type WhyChooseTechnologySectionProps = {
  whyChooseTechData: WhyChooseTechSectionType;
};

const WhyChooseTechnologySection = ({
  whyChooseTechData,
}: WhyChooseTechnologySectionProps) => {
  return (
    <section className=" whyChooseTechnology_section">
      <div className="app_section">
        <div className="appSection_header_container">
          <h1 className="section_title">{whyChooseTechData.title}</h1>
          <p className="section_description">{whyChooseTechData.description}</p>
        </div>
        <div className="whyChooseTechnologyCards_container">
          {whyChooseTechData.data.map((whyChooseTech, index) => (
            <WhyChooseTechCard
              key={"WhyChooseTechCard" + index}
              whyChooseTech={whyChooseTech}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseTechnologySection;
